import type { PropsWithChildren } from "react";
import { Link, type InertiaLinkProps } from "@inertiajs/react";
import cx from "classnames";

import usePage from "@/hooks/usePage";

type NavLinkProps = Omit<InertiaLinkProps, "href"> & {
  exact?: boolean;
  href: string;
};

export function NavLink({
  children,
  href,
  exact = true,
  ...rest
}: PropsWithChildren<NavLinkProps>) {
  const { url } = usePage<{ user: any } & AdminUsePageProps>();
  const hrefWithoutOrigin =
    typeof window === "undefined"
      ? ""
      : href.replace(window.location.origin, "");

  return (
    <Link
      {...rest}
      href={href}
      className={cx("flex items-center gap-1.5 py-1.5 px-2 rounded", {
        "bg-gray-200 hover:bg-white": exact
          ? href.endsWith(url)
          : url.includes(hrefWithoutOrigin),
        "text-gray-700 hover:bg-gray-50 hover:text-black": exact
          ? !href.endsWith(url)
          : !url.includes(hrefWithoutOrigin),
      })}
    >
      {children}
    </Link>
  );
}
